import {createFragmentContainer, graphql} from 'react-relay';
import {PROGRAM_BUDGET_TYPE} from '../../../../constants';

const TotalsLoader = ({relay, viewer, children, ...props}) => {
	let unallocatedRevenueTotal = 0;
	viewer.company.financialBasedPrograms?.edges.forEach(program => {
		const {projectsFinancialsTotals} = program.node;
		unallocatedRevenueTotal +=
			projectsFinancialsTotals.unallocatedRevenue && program.node.budgetType === PROGRAM_BUDGET_TYPE.FIXED_PRICE
				? projectsFinancialsTotals.unallocatedRevenue
				: 0;
	});

	const formatData = () => {
		return [
			{
				currency: viewer.company.currency,
				isTotalsRow: true,
				unallocatedRevenueTotal: unallocatedRevenueTotal,
				financialNumbers: {
					...viewer.company.financialNumbers,
				},
			},
		];
	};
	return children({data: {rows: formatData()}, ...props});
};

export const totalsLoaderQuery = graphql`
	query TotalsLoader_Query(
		$startYear: Int
		$startMonth: Int
		$startDay: Int
		$endYear: Int
		$endMonth: Int
		$endDay: Int
		$searchQuery: TaskSearchQueryType!
		$ignoreBaselineWinChance: Boolean
		$excludeOpportunityActuals: Boolean
	) {
		viewer {
			actualPersonId
			component(name: "project_portfolio_period_totals_loader")
			...TotalsLoader_viewer
				@arguments(
					searchQuery: $searchQuery
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
					ignoreBaselineWinChance: $ignoreBaselineWinChance
					excludeOpportunityActuals: $excludeOpportunityActuals
				)
		}
	}
`;

export default createFragmentContainer(TotalsLoader, {
	viewer: graphql`
		fragment TotalsLoader_viewer on Viewer
		@argumentDefinitions(
			searchQuery: {type: "TaskSearchQueryType!"}
			startYear: {type: "Int"}
			startMonth: {type: "Int"}
			startDay: {type: "Int"}
			endYear: {type: "Int"}
			endMonth: {type: "Int"}
			endDay: {type: "Int"}
			ignoreBaselineWinChance: {type: "Boolean"}
			excludeOpportunityActuals: {type: "Boolean"}
		) {
			id
			company {
				currency
				financialNumbers(
					searchQuery: $searchQuery
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
					ignoreBaselineWinChance: $ignoreBaselineWinChance
					excludeOpportunityActuals: $excludeOpportunityActuals
				) {
					billableActualTimeAndExpenses
					totalActualRevenueRecognition
					actualCost
					actualRevenueProfit
					actualRevenueMargin
					billablePlannedTimeAndExpenses
					plannedRevenue
					plannedCost
					plannedRevenueProfit
					plannedRevenueMargin
					billableForecastTimeAndExpensesToComplete
					totalForecastRevenueToComplete
					forecastCostToComplete
					forecastRevenueProfitToComplete
					forecastRevenueMarginToComplete
					billableTotalTimeAndExpensesAtCompletion
					nonBillableTotalTimeAndExpensesAtCompletion
					allTotalTimeAndExpensesAtCompletion
					totalRevenueRecognition
					totalCostAtCompletion
					totalRevenueProfitAtCompletion
					totalRevenueMarginAtCompletion
					baselineRevenue
					baselineTimeAndExpenses
					baselineCost
					baselineProfit
					baselineMargin
					baselineMinutes
					planVsBillableActualTimeAndExpenses
					planVsActualCost
					planVsActualRevenueProfit
					planVsActualRevenueRecognition
					planVsTotalRevenueAtCompletion
					planVsTotalBillableTimeAndExpensesAtCompletion
					planVsTotalCostAtCompletion
					planVsTotalRevenueProfitAtCompletion
					registeredMinutes
					forecastTimeToComplete
					totalTimeAtCompletion
					totalSuggestedRevenue
					scopeApprovedMinutes
					invoiced
					paid
					accruedDeferred
					retainerPeriodTargetMinutes
					retainerPeriodTargetPrice
					recognitionLockedRevenue
					recognitionOpenRevenue
					totalRevenueRecognition
					unallocatedRevenue
					programBudgetValue
					projectedTotalRevenueVsProjectedTotalBillableValueOfService
					projectedTotalRevenueVsProjectedTotalValueOfService
					recognitionForecastRevenue
				}
				financialBasedPrograms(
					searchQuery: $searchQuery
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
					ignoreBaselineWinChance: $ignoreBaselineWinChance
					excludeOpportunityActuals: $excludeOpportunityActuals
				) {
					edges {
						node {
							budgetType
							projectsFinancialsTotals {
								unallocatedRevenue
							}
						}
					}
				}
			}
		}
	`,
});
